"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5551],{

/***/ 30040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85169);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49613);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64370);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24452);
/* harmony import */ var _ecosystems_Favoriting__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21158);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47493);
/* harmony import */ var _lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73074);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}









var ButtonFavoriteVideoCard = function ButtonFavoriteVideoCard(props) {
  var _useLoginModal = (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(),_useLoginModal2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useLoginModal, 2),modal = _useLoginModal2[0],openModal = _useLoginModal2[1].openModal;
  var theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_11__.ThemeContext);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_7__/* .UserContext */ .S),currentUser = _useContext[0],userLoading = _useContext[1].loading;

  var handleFavoriting = /*#__PURE__*/function () {var _ref = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(onClickFavoriteHandler) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!(
              currentUser !== null && currentUser !== void 0 && currentUser.id)) {_context.next = 5;break;}_context.next = 3;return (
                onClickFavoriteHandler());case 3:_context.next = 6;break;case 5:

              openModal();case 6:case "end":return _context.stop();}}}, _callee);}));return function handleFavoriting(_x) {return _ref.apply(this, arguments);};}();



  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_ecosystems_Favoriting__WEBPACK_IMPORTED_MODULE_6__/* .VideoFavoriting */ .l, { videoId: props.videoId, children:
      function children(_ref2) {var isFavoritedVideoById = _ref2.isFavoritedVideoById,onClickFavoriteHandler = _ref2.onClickFavoriteHandler,loading = _ref2.loading;return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, { children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* .StyledMaterialButton */ .er, _objectSpread(_objectSpread({
              onClick: function onClick() {return handleFavoriting(onClickFavoriteHandler);} },
            loading || userLoading ? { disabled: true, loading: loading } : {}), {}, { children:


              loading ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, { children: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                  style: { padding: '10px' },
                  size: 10,
                  spinnerColor: "#7d7d7d" }),

                isFavoritedVideoById ? /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_13__/* .Trans */ .cC, {
                  id: "metadata.saved_favorites",
                  message: "Saved to favorites" }) : /*#__PURE__*/


                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_13__/* .Trans */ .cC, {
                  id: "metadata.save_favorites",
                  message: "Save to favorites" })] }) : /*#__PURE__*/




              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                icon:
                isFavoritedVideoById ?
                'ygb-icon-heart-filled' :
                'ygb-icon-heart-outline',

                iconColor:
                isFavoritedVideoById ?
                theme.colors.primary['blue-2'] :
                theme.colors.neutrals.black,

                iconSize: '15px',
                uppercase: true, children:

                isFavoritedVideoById ? /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_13__/* .Trans */ .cC, {
                  id: "metadata.saved_favorites",
                  message: "Saved to favorites" }) : /*#__PURE__*/


                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_13__/* .Trans */ .cC, {
                  id: "metadata.save_favorites",
                  message: "Save to favorites" }) }) })),





            modal] }));} }));




};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonFavoriteVideoCard);

/***/ }),

/***/ 28384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ LinkStyleUserSubHeader; },
/* harmony export */   "d9": function() { return /* binding */ LinkStyleMetadata; },
/* harmony export */   "vb": function() { return /* binding */ LinkStyleSettingsReceipts; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var LinkStyleSettingsReceipts = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({ displayName: "links__LinkStyleSettingsReceipts", componentId: "sc-65t1yc-0" })(["text-decoration:none;cursor:pointer;font-size:13px;font-weight:300;color:", ";&:hover{color:", ";}"],




function (props) {return props.theme.colors.primary['blue-2'];},


function (props) {return (
    props.color ? props.color : props.theme.colors.primary['blue-1']);});



var LinkStyleUserSubHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({ displayName: "links__LinkStyleUserSubHeader", componentId: "sc-65t1yc-1" })(["text-decoration:none;color:inherit;"]);




var LinkStyleMetadata = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({ displayName: "links__LinkStyleMetadata", componentId: "sc-65t1yc-2" })(["color:", ";font-weight:", ";font-size:13px;text-decoration:none;cursor:pointer;text-transform:capitalize;&:hover{color:", ";}"],
function (props) {return (
    props.color ? props.color : props.theme.colors.primary['blue-2']);},
function (props) {return props.bold ? '600' : 'normal';},






function (props) {return (
    props.color ? props.color : props.theme.colors.primary['blue-1']);});

/***/ }),

/***/ 50996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17516);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49613);
/* harmony import */ var _components_links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28384);
/* harmony import */ var _organisms_modals_InstructorModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75115);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Separator = function Separator(props) {
  if (props.index + 1 < props.length - 1) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: ",\xA0" });
  } else {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
        ' ', /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.and", message: 'and' }), ' '] }));


  }
};








var GenreInstructorMetadata = function GenreInstructorMetadata(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  var _props$instructors = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props.instructors),first = _props$instructors[0],rest = _props$instructors.slice(1);

  var firstInstructor = null;
  if (first) {
    if (props.openInVideos) {
      var asPath = "/".concat(locale, "/videos/genres/all?instructors=").concat(first.slug);
      firstInstructor = /*#__PURE__*/
      // ISSUE WITH THE [GENRE] PAGE, FRONTEND ROUTING WITH PARAMS DOES NOT DETECT PARAMS...
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), { href: asPath, shallow: false, legacyBehavior: true, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { appearance: "link", href: asPath, children:
          first.name }) });



    } else {
      firstInstructor = /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_InstructorModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { slug: first.slug, children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
              appearance: "link",
              onClick: handleOpenModal, children:


              first.name }));} });




    }
  }

  var typeContent = null;
  if (props.primaryStyle) {var _props$primaryStyle, _props$primaryStyle2;
    typeContent = /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: {
          pathname: "/".concat(locale, "/videos/genres/all"),
          query: { styles: (_props$primaryStyle = props.primaryStyle) === null || _props$primaryStyle === void 0 ? void 0 : _props$primaryStyle.slug } },

        legacyBehavior: true, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_links__WEBPACK_IMPORTED_MODULE_4__/* .LinkStyleMetadata */ .d9, { bold: true, children: [(_props$primaryStyle2 =
          props.primaryStyle) === null || _props$primaryStyle2 === void 0 ? void 0 : _props$primaryStyle2.name, " "] }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.with", message: 'med' }), " "] });



  } else if (props.genre) {
    typeContent = /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), { href: "/".concat(locale, "/videos/genres/").concat(props.genreSlug), legacyBehavior: true, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_links__WEBPACK_IMPORTED_MODULE_4__/* .LinkStyleMetadata */ .d9, { bold: true, children: [
          props.genre, " "] }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.with", message: 'med' }), " "] });



  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: [
      typeContent,
      firstInstructor,
      rest &&
      rest.length < 3 &&
      rest.map(function (instructor, index) {return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_InstructorModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { slug: instructor.slug, children:
            function children(handleOpenModal) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Separator, { index: index, length: rest.length }), /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { appearance: "link", onClick: handleOpenModal, children:
                    instructor.name })] }));} }, index));}),






      rest && rest.length >= 3 && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
        ' ', /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.and", message: 'and' }), " ", rest.length, ' ', /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.more", message: 'more' })] })] }));




};

/* harmony default export */ __webpack_exports__["Z"] = (GenreInstructorMetadata);

/***/ }),

/***/ 90972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94997);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({ displayName: "Card__Wrapper", componentId: "sc-1gywtub-0" })(["border:", ";border-radius:5px;background-color:#ffffff;overflow:hidden;a{text-decoration:none;}"],
function (props) {return props.borderless ? 'none' : '1px solid #eeeeee';});









var DescriptionWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({ displayName: "Card__DescriptionWrapper", componentId: "sc-1gywtub-1" })([""]);

var RedirectTo = function RedirectTo(props) {
  var params = props.redirectTo;
  if (typeof props.redirectTo === 'string') {
    params = { href: props.redirectTo };
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, params), {}, { children:
      props.children })));


};

var ThumbnailSection = function ThumbnailSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children:
        props.thumbnailUrl ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) : /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: "/static/playlist-empty-ic.svg",
          withRadius: true, children:

          props.thumbnailContent }) }));




  }

  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) }));



  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
      large: props.large,
      path: props.thumbnailUrl,
      withRadius: true, children:

      props.thumbnailContent }));


};

var TitleSection = function TitleSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle });
};




















var Card = function Card(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);

  return props.large ? /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: /*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "0 0 407px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
          href: props.href,
          redirectTo: props.redirectTo ? props.redirectTo : null,
          thumbnailContent: props.thumbnailContent,
          thumbnailUrl: props.thumbnailUrl,
          locale: locale,
          large: true }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "1", px: "25px", py: "20px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
          flexDirection: "column",
          justifyContent: "space-between",
          style: { height: '100%' }, children: [/*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
                contentTitle: props.contentTitle,
                redirectTo: props.redirectTo,
                locale: locale }) }),


            props.contentAuthor ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

            null, /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children:
              props.isContentDescriptionHTML ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, {
                dangerouslySetInnerHTML: {
                  __html: props.contentDescription } }) : /*#__PURE__*/



              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) })] }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { mx: "-10px", children:
                  props.contentLeftCardLargeSection.map(function (item, index) {return /*#__PURE__*/(
                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "10px", children:
                        item }, index));}) }) }), /*#__PURE__*/




              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentRightCardLargeSection })] }) })] }) })] }) }) : /*#__PURE__*/







  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: [/*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { onClick: props.onClick, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
        href: props.href,
        redirectTo: props.redirectTo,
        thumbnailContent: props.thumbnailContent,
        thumbnailUrl: props.thumbnailUrl,
        locale: locale }) }), /*#__PURE__*/


    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "25px", py: "20px", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
          href: props.href,
          contentTitle: props.contentTitle,
          redirectTo: props.redirectTo,
          locale: locale }) }),


      props.contentAuthor ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

      null, /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DescriptionWrapper, { mb: "10px", children:
        props.isContentDescriptionHTML ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescriptionDivStyledP */ .DY, {
          dangerouslySetInnerHTML: {
            __html: props.contentDescription } }) : /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardLeftSection }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardRightSection })] })] })] });




};

Card.toString = Wrapper.toString;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 85551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31157);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42227);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69295);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85169);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38396);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37702);
/* harmony import */ var _components_ButtonFavoriteVideoCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30040);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49613);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54444);
/* harmony import */ var _ecosystems_ButtonAddtoPlaylist__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98648);
/* harmony import */ var _ecosystems_ButtonScheduleModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35602);
/* harmony import */ var _ecosystems_GenreInstructorMetadata__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50996);
/* harmony import */ var _ecosystems_MenuItemShareModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5822);
/* harmony import */ var _lib_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62594);
/* harmony import */ var _organisms_cards_Card__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90972);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17516);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);
var _excluded = ["className", "video", "large", "locked", "redirectTo", "onClick", "tags", "disableActionButtons"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

















var BottomRightWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].span.withConfig({ displayName: "VideoCard__BottomRightWrapper", componentId: "sc-1dsnl91-0" })(["position:absolute;right:6px;bottom:6px;"]);





var DurationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].span.withConfig({ displayName: "VideoCard__DurationWrapper", componentId: "sc-1dsnl91-1" })(["background-color:rgba(0,0,0,0.75);font-size:11px;font-weight:500;color:", ";text-align:center;border-radius:4px;padding:5px 7px;display:block;"],



function (props) {return props.theme.colors.neutrals.white;});






var Badge = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].span.withConfig({ displayName: "VideoCard__Badge", componentId: "sc-1dsnl91-2" })(["display:flex;color:", ";font-size:11px;font-weight:500;text-transform:uppercase;border-radius:5px;padding:4px;margin-right:5px;background-color:", ";"],

function (props) {return props.theme.colors.neutrals['white'];},






function (props) {return props.backgroundColor;});


var CenterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "VideoCard__CenterWrapper", componentId: "sc-1dsnl91-3" })(["position:absolute;width:19px;height:19px;left:50%;top:50%;transform:translate(-50%,-50%);border:2px solid #fff;border-radius:50%;padding:29px;box-shadow:0;transition:all 0.3s;"]);













var PlayIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "VideoCard__PlayIconWrapper", componentId: "sc-1dsnl91-4" })(["position:absolute;top:55%;left:54%;transform:translate(-50%,-50%);z-index:1;"]);







var TopLeftWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "VideoCard__TopLeftWrapper", componentId: "sc-1dsnl91-5" })(["position:absolute;top:5px;left:5px;display:flex;"]);






var ThumbnailWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "VideoCard__ThumbnailWrapper", componentId: "sc-1dsnl91-6" })(["align-items:center;justify-content:center;display:flex;width:100%;height:100%;&:hover{cursor:pointer;}&:hover > .changeBackgroundOnHover{box-shadow:0px 0px 14px 0px rgba(0,0,0,0.75);}", ";:after{content:'';position:absolute;left:0;bottom:0;height:4px;width:", "%;background-color:#129edc;}"],














function (props) {return (
    props.locked ? "\n          &:before {\n            content: '';\n            opacity: 0.8;\n            background: ".concat(




    props.theme.colors.secondary['green-4'], ";\n            position: absolute;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n          }\n        ") :







    null);},







function (_ref) {var progress = _ref.progress;return progress || 0;});




var TagsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div.withConfig({ displayName: "VideoCard__TagsWrapper", componentId: "sc-1dsnl91-7" })(["position:absolute;top:0;left:0;display:flex;align-items:start;height:100%;width:100%;padding:10px;"]);










var VideoTag = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].span.withConfig({ displayName: "VideoCard__VideoTag", componentId: "sc-1dsnl91-8" })(["color:", ";border-radius:3px;padding:5px;margin-right:8px;background-color:", ";"],
function (props) {return props.theme.colors.neutrals.white;},



function (props) {return props.theme.colors.secondary.blue;});


var VideoCard = function VideoCard(_ref2)









{var _ref2$className = _ref2.className,className = _ref2$className === void 0 ? '' : _ref2$className,video = _ref2.video,_ref2$large = _ref2.large,large = _ref2$large === void 0 ? false : _ref2$large,_ref2$locked = _ref2.locked,locked = _ref2$locked === void 0 ? false : _ref2$locked,_ref2$redirectTo = _ref2.redirectTo,redirectTo = _ref2$redirectTo === void 0 ? null : _ref2$redirectTo,_ref2$onClick = _ref2.onClick,onClick = _ref2$onClick === void 0 ? null : _ref2$onClick,_ref2$tags = _ref2.tags,tags = _ref2$tags === void 0 ? [] : _ref2$tags,_ref2$disableActionBu = _ref2.disableActionButtons,disableActionButtons = _ref2$disableActionBu === void 0 ? false : _ref2$disableActionBu,otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_ref2, _excluded);
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),anchorElMenu = _useState[0],setAnchorElMenu = _useState[1];
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),rightMenuOpen = _useState2[0],setRightMenuOpen = _useState2[1];

  var handleOpenMenu = function handleOpenMenu(event) {
    setAnchorElMenu(event.currentTarget);
    setRightMenuOpen(true);
  };

  var handleCloseMenu = function handleCloseMenu() {
    setRightMenuOpen(false);
    setAnchorElMenu(null);
  };

  var now = new Date();
  var publishedAt = (0,date_fns__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(video.publishedAt);
  var isNew = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(now, publishedAt) <= 12;
  var isAudio = video.kind === 'audio';

  var dataProps = Object.entries(otherProps).
  filter(function (_ref3) {var _ref4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_ref3, 1),key = _ref4[0];return key.startsWith('data-');}).
  reduce(function (object, _ref5) {var _ref6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_ref5, 2),key = _ref6[0],value = _ref6[1];
    object[key] = value;
    return object;
  }, {});

  var progress =
  (video === null || video === void 0 ? void 0 : video.cursorAt) > 0 ?
  Math.floor((video === null || video === void 0 ? void 0 : video.cursorAt) / 60 * 100 / (video === null || video === void 0 ? void 0 : video.duration)) :
  0;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_organisms_cards_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, _objectSpread({
      className: className,
      large: large,
      onClick: onClick,
      redirectTo:
      !onClick ?
      locked ?
      null :
      redirectTo ?
      redirectTo : "/".concat(
      locale, "/videos/").concat(video.identifier) :
      null,

      thumbnailUrl: video.thumbnailUrl,
      thumbnailContent: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(ThumbnailWrapper, { locked: locked, progress: progress, children: [
        !locked ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(CenterWrapper, { className: "changeBackgroundOnHover", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(PlayIconWrapper, { children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { name: "ygb-icon-play", color: "white", fontSize: "17.5px" }) }) }) }) : /*#__PURE__*/




        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          name: "ygb-icon-programlock-ic",
          color: "white",
          fontSize: "30px",
          style: { zIndex: 1 } }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(TopLeftWrapper, { children: [
          isNew ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Badge, { backgroundColor: _lib_theme__WEBPACK_IMPORTED_MODULE_9__/* ["default"].colors.primary["blue-2"] */ .Z.colors.primary["blue-2"], children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_18__/* .Trans */ .cC, { id: "metadata.new" }) }) :

          null,
          video.flavor && video.flavor != 'Tutorial' ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Badge, { backgroundColor: "#454857", children: video.flavor }) :
          null,
          isAudio ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Badge, { backgroundColor: "#454857", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", { width: "14px", src: "/static/icons/HeadSetIcon.svg" }) }) :

          null] }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(BottomRightWrapper, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(DurationWrapper, { children: [
            video.duration, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_18__/* .Trans */ .cC, { id: "metadata.min" })] }) }),


        tags && /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(TagsWrapper, { children:
          tags === null || tags === void 0 ? void 0 : tags.map(function (tag) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(VideoTag, { children: tag }, tag));}) })] }),





      contentTitle: video.title,
      contentAuthor: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_GenreInstructorMetadata__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        genre: video.genreName,
        genreSlug: video.genreSlug,
        primaryStyle: video.primaryStyle,
        instructors: video.instructors }),


      contentDescription: video.description,
      contentCardLeftSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_ButtonFavoriteVideoCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { videoId: video.id }),


      contentCardRightSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* .StyledMaterialButton */ .er, {
          onClick: handleOpenMenu, children: /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { name: "ygb-icon-menu-hor", fontSize: "5px" }) }),

        rightMenuOpen ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
          id: "video-card-right-menu",
          anchorEl: anchorElMenu,
          open: rightMenuOpen,
          onClose: handleCloseMenu,
          keepMounted: true, children: [/*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_ButtonAddtoPlaylist__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            tag: _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z,
            videoId: video.id,
            handleCloseParentMenu: handleCloseMenu,
            anchorElMenu: anchorElMenu,
            handleOpenParentMenu: function handleOpenParentMenu() {
              handleOpenMenu({
                currentTarget: anchorElMenu });

            },
            onModalClose: handleCloseMenu }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_ButtonScheduleModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            tag: _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z,
            resource: "video",
            resourceId: video.id,
            onModalClose: handleCloseMenu }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_MenuItemShareModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            resourceIdentifier: video.identifier,
            resource: "videos",
            onModalClose: handleCloseMenu })] }) :


        null] }),



      contentLeftCardLargeSection:
      disableActionButtons ?
      [] :
      [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_ButtonFavoriteVideoCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { videoId: video.id }, 1), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_ButtonAddtoPlaylist__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {

        tag: _components_buttons__WEBPACK_IMPORTED_MODULE_3__/* .StyledMaterialButton */ .er,
        videoId: video.id,
        handleCloseParentMenu: handleCloseMenu }, 2), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_ButtonScheduleModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {

        tag: _components_buttons__WEBPACK_IMPORTED_MODULE_3__/* .StyledMaterialButton */ .er,
        resource: "video",
        resourceId: video.id }, 3)],



      contentRightCardLargeSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* .StyledMaterialButton */ .er, { onClick: handleOpenMenu, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { name: "ygb-icon-menu-hor", fontSize: "5px" }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
          id: "video-card-menu",
          anchorEl: anchorElMenu,
          keepMounted: true,
          open: Boolean(anchorElMenu),
          onClose: handleCloseMenu, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ecosystems_MenuItemShareModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            resourceIdentifier: video.identifier,
            resource: "videos" }) })] }) },





    dataProps)));


};

/* harmony default export */ __webpack_exports__["Z"] = (VideoCard);

/***/ })

}]);